import { render, staticRenderFns } from "./set_passwod.vue?vue&type=template&id=71e8de13&scoped=true"
import script from "./set_passwod.vue?vue&type=script&lang=js"
export * from "./set_passwod.vue?vue&type=script&lang=js"
import style0 from "./set_passwod.vue?vue&type=style&index=0&id=71e8de13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e8de13",
  null
  
)

export default component.exports